var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Iconz/bag"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.232 5.23V3.294c0-.385-.179-.754-.496-1.026a1.846 1.846 0 0 0-1.197-.425H9.461c-.449 0-.88.153-1.197.425a1.354 1.354 0 0 0-.496 1.026v1.934M9.178 12v3.385H5.795V12m3.385 0h6.206M9.18 12H5.794m0 0h-3.95m20.312 0h-3.385m0 0h-3.386m3.386 0v3.385h-3.386V12M5.23 22.156h13.542a3.385 3.385 0 0 0 3.385-3.385V8.615a3.385 3.385 0 0 0-3.385-3.386H5.229a3.385 3.385 0 0 0-3.385 3.386V18.77a3.385 3.385 0 0 0 3.385 3.385Z",
    className: "iconz"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.c5454bd843c48b53b939eaacb23c6867.svg";
export { ForwardRef as ReactComponent };